import { Cache } from "memory-cache";
import { AssetEntity } from ".";
// Cache
const cache = new Cache();

export async function getCachedAssetEntity(asset_id: number): Promise<AssetEntity | null> {
  let entity: any = await cache.get(asset_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}

export function setCachedAssetEntity(asset: AssetEntity) {
  cache.put(asset.props.item_id.toString(), asset, 60 * 60 * 1000 /* 1 hour */);
}
